import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationService } from 'src/app/_services/navigation';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {
  @Input() returnAction?: string ="";
  @Input() breadcrumbs: { label: string, url?: string }[] = [];

  backUrl="/dashboard";

  @Output() confirmedClick = new EventEmitter();
  constructor(
    private navigation: NavigationService,
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  backBtn(action:string){
    switch (action) {
      case 'location.reload()':
        location.reload()
        break;
      case 'location.back()':
        this.navigation.back()
        break;
      case '/':
        this.router.navigate(['/dashboard']);
        break;
      default:
        this.router.navigate(['/dashboard']);
      }
    }
}